import ConfirmButton from './ConfirmButton'
export { ConfirmButton }
export default ConfirmButton



// WEBPACK FOOTER //
// ./src/components/ConfirmButton/index.js